
<header class="app-header" role="banner">
  <div class="left">
    <a class="brand" routerLink="/">DIAGNOSTICS TOOL</a>
  </div>

  <div class="right">
    <div class="greet">
      Hello<span class="comma">,</span>
      @if (authLoading) {
        <span class="username-skeleton" aria-label="Loading..." role="status"></span>
      } @else {
        <span class="username" [title]="displayName()">{{ displayName() }}</span>
      }
    </div>

    <!-- User menu button -->
    <button
      type="button"
      class="avatar-btn"
      aria-label="User menu"
      aria-haspopup="menu"
      [attr.aria-expanded]="menuOpen()"
      (click)="toggleMenu()"
    >
      <!-- simple avatar circle with initials -->
      <span class="avatar">
        {{ computeInitials() }}
      </span>
      <span class="chevron" aria-hidden="true">▾</span>
    </button>

    <!-- Dropdown menu -->
    @if (menuOpen()) {
      <div class="menu" role="menu" (mouseleave)="closeMenu()">
        <button role="menuitem" class="menu-item" (click)="onMenu('profile')">
          <span class="icon">👤</span>
          <span>Profile</span>
        </button>
        <div class="sep" aria-hidden="true"></div>
        <button 
          role="menuitem" 
          class="menu-item danger" 
          (click)="onMenu('signout')"
          [disabled]="isSigningOut()"
          [title]="isSigningOut() ? 'Signing out...' : 'Sign out'"
        >
          <span class="icon" [attr.aria-busy]="isSigningOut()">
            {{ isSigningOut() ? '⏳' : '🚪' }}
          </span>
          <span>{{ isSigningOut() ? 'Signing out...' : 'Sign out' }}</span>
        </button>
      </div>
    }
  </div>
</header>
